export default __webpack_public_path__ + "static/media/BOD Special Meeting 07 April 2021.f68ccd4f.pdf";